import { render, staticRenderFns } from "./WebAddressPhoneSelectorModal.vue?vue&type=template&id=e3ac1dc4&scoped=true"
import script from "./WebAddressPhoneSelectorModal.vue?vue&type=script&lang=js"
export * from "./WebAddressPhoneSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./WebAddressPhoneSelectorModal.vue?vue&type=style&index=0&id=e3ac1dc4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ac1dc4",
  null
  
)

export default component.exports